import { ApolloLink, FetchResult, NextLink, Observable, Operation } from "@apollo/client";

function headerValue(token: string): string {
    return `Invitation ${token}`;
}

export const createHttpAuthLink = () => {
    return new ApolloLink((operation, forward) => {
        const token = operation.getContext().token;

        if (!token) return forward(operation);

        const extraHeaders = {
            authorization: headerValue(token),
        };

        console.debug("set extra headers %o to operation %s for chatto", extraHeaders, operation.operationName);
        operation.setContext(({ headers }: { headers?: Record<string, string> }) => ({
            headers: {
                ...headers,
                ...extraHeaders,
            },
        }));

        return forward(operation);
    });
};

/// a RequestHandler for creating an apollo link that adds authorization information to the extensions
export function addAuthorizationToExtensions(operation: Operation, forward: NextLink): Observable<FetchResult> | null {
    const token = operation.getContext().token;
    if (token) {
        operation.extensions["authorization"] = headerValue(token);
    }
    return forward(operation);
}
